import { http } from '@pendo/http';

export function getJiraProjects ({ startAt, maxResults }) {
    return http
        .post(
            '/api/s/_SID_/vocItem/jira/projects',
            {
                startAt,
                maxResults,
            },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function createJiraIssue ({ fields, vocItemId, isPrimary }) {
    return http
        .post('/api/s/_SID_/vocItem/jira/issue', {
            fields,
            vocItemId,
            isPrimary,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getJiraServerInfo () {
    return http
        .get('/api/s/_SID_/vocItem/jira/serverinfo')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function loadDetailsForJiraIssue ({ vocItemId, jiraIssueId }) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/jiraIssues/${jiraIssueId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function loadAllJiraIssuesForVocItem (vocItemId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/jiraIssues`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function unlinkJiraIssue ({ vocItemId, jiraIssueId }) {
    return http.delete(`/api/s/_SID_/vocItem/${vocItemId}/jiraIssues/${jiraIssueId}`).catch((err) => {
        throw err;
    });
}

export function searchJiraIssues ({ projects, query, issueTypes = null }) {
    return http
        .post('/api/s/_SID_/vocItem/jira/issuePicker', {
            projects,
            query,
            ...(issueTypes && { issueTypes }),
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getJiraIssueDetails ({ issues }) {
    return http
        .post('/api/s/_SID_/vocItem/jira/issues', {
            issues,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export async function linkJiraIssueToVocItem ({ vocItemId, issues }) {
    return http
        .post('/api/s/_SID_/vocItem/jira/linkIssue', {
            vocItemId,
            issues,
        })
        .then((res) => res.data.map((r) => r.body))
        .catch((err) => {
            throw err;
        });
}

export function getJiraFields ({ projectId, issueTypeId }) {
    return http
        .get(`/api/s/_SID_/vocItem/jira/${projectId}/issueType/${issueTypeId}/fields`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getJiraFieldSuggestions ({ type, query = '' }) {
    return http
        .get(`/api/s/_SID_/vocItem/jira/field/suggestions/${type}?query=${encodeURIComponent(query)}`)
        .then((res) => res.data?.results || [])
        .catch((err) => {
            throw err;
        });
}

export function getJiraAssignableUsers ({ projectId, query = '' }) {
    return http
        .get(`/api/s/_SID_/vocItem/jira/projects/${projectId}/users?query=${encodeURIComponent(query)}`)
        .then((res) => res.data || [])
        .catch((err) => {
            throw err;
        });
}

export function getJiraInstances () {
    return http
        .get('/api/s/_SID_/ipaas/solutioninstances/tag/discover-jira')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getJiraAvatar ({ type, id }) {
    return http
        .get(`/api/s/_SID_/vocItem/jira/universal_avatar/owner/${type}/${id}`)
        .then((res) => res)
        .catch((err) => {
            throw err;
        });
}

export function getJiraProjectsAndIssueTypes () {
    return http
        .get('/api/s/_SID_/vocItem/jira/projects/all')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getJiraStatuses (projectIds, signal) {
    return http
        .post('api/s/_SID_/vocItem/jira/status', { projectIds }, { signal })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function saveListenJiraConfiguration ({ configuration }) {
    return http
        .post('/api/s/_SID_/vocItem/jira/settings', configuration)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getListenJiraConfiguration () {
    return http
        .get('/api/s/_SID_/vocItem/jira/settings')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function setPrimarySyncedIssue ({ vocItemId, jiraIssueId }) {
    return http
        .patch(`/api/s/_SID_/vocItem/${vocItemId}/jiraIssues/setprimary`, {
            issueId: jiraIssueId,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
